module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABjSURBVHgB7ZFRCsAgDEODJ9gN15vvCO4GXYWOlaESv/TDB4UQJJYGqnraZJuraDi07+Ilh4eUn8w78HEHzfmWIp5a1pLw05A/kd2CYD67BcG6tFoYCai28Cd1Mlot0BtQ134ALeDJrKLtjgkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-eight/dot.png
// module id = 2mCC
// module chunks = 0